var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYellowTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.9999C16.4999 12.3004 16.0391 13.5588 15.1994 14.5519C14.3597 15.545 13.1954 16.2085 11.913 16.4248C11.4134 16.5073 11 16.0893 11 15.5833V6.41659C11 5.91059 11.4134 5.49168 11.913 5.57509C13.1954 5.79134 14.3597 6.45486 15.1994 7.44793C16.0391 8.44101 16.4999 9.69943 16.5 10.9999Z",
    stroke: "#F4B902",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7992 11.0002C19.7992 12.1558 19.5716 13.3001 19.1294 14.3678C18.6871 15.4355 18.0389 16.4056 17.2218 17.2227C16.4046 18.0399 15.4345 18.6881 14.3668 19.1303C13.2992 19.5726 12.1549 19.8002 10.9992 19.8002C9.25875 19.8002 7.55736 19.2841 6.1102 18.3171C4.66305 17.3502 3.53513 15.9758 2.86908 14.3678C2.20303 12.7598 2.02876 10.9904 2.36831 9.2834C2.70786 7.57637 3.54598 6.00836 4.77668 4.77766C6.00739 3.54696 7.5754 2.70884 9.28243 2.36929C10.9895 2.02974 12.7588 2.20401 14.3668 2.87006C15.9748 3.53611 17.3492 4.66403 18.3162 6.11118C19.2831 7.55833 19.7992 9.25972 19.7992 11.0002Z",
    stroke: "#F4B902",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYellowTick);
export default __webpack_public_path__ + "static/media/icon_yellow_tick.0ae8e961a4a3abb8527acfdbf3cf087f.svg";
export { ForwardRef as ReactComponent };